import { Component, OnInit } from '@angular/core';
import { AnimationOptions } from 'ngx-lottie';
@Component({
  selector: 'app-whycard1',
  templateUrl: './whycard1.component.html',
  styleUrls: ['./whycard1.component.css']
})
export class Whycard1Component implements OnInit {
  options: AnimationOptions = {
    path: '/assets/animations/flow1.json' // Path to your animation file
  };
  constructor() { }

  ngOnInit(): void {
  }

}
